import React, { useState } from 'react';
import { BLOCK } from '../data/constants';
import { parseBody } from './richText';
const Chevron = ({
  open
}) => React.createElement("svg", {
  className: `cp-rbchev${open ? ' is-open' : ''}`,
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("path", {
  d: "M6 9l6 6 6-6"
}));

// Collapsed until asked for, and it forgets on close: this is a reference the
// client opens while reading, not a setting.
const Help = ({
  block
}) => {
  const [open, setOpen] = useState(false);
  return React.createElement("div", {
    className: `cp-rbhelp${open ? ' is-open' : ''}`
  }, React.createElement("button", {
    type: "button",
    className: "cp-rbhelp-toggle",
    "aria-expanded": open,
    onClick: () => setOpen(v => !v)
  }, React.createElement("span", null, block.question), React.createElement(Chevron, {
    open: open
  })), open && React.createElement("div", {
    className: "cp-rbhelp-body"
  }, block.intro && React.createElement("p", {
    className: "cp-ivbody"
  }, block.intro), !!block.items.length && React.createElement("ul", {
    className: "cp-rblist"
  }, block.items.map(item => React.createElement("li", {
    key: item
  }, item)))));
};

// Guidance, not options: nothing here is pickable, so there is no tick, no
// hover state and no click target but the help toggle.
const Card = ({
  block
}) => React.createElement("div", {
  className: "cp-rbcard"
}, React.createElement("p", {
  className: "cp-rbcard-title"
}, block.title), block.badge && React.createElement("span", {
  className: "cp-rbbadge"
}, block.badge), block.text && React.createElement("p", {
  className: "cp-rbcard-body"
}, block.text));

// Cards stand together in a grid, so consecutive ones are drawn as one run.
const runs = blocks => {
  const out = [];
  blocks.forEach(block => {
    const last = out[out.length - 1];
    if (block.type === BLOCK.CARD && last && last.type === BLOCK.CARDS) {
      last.items.push(block);
      return;
    }
    out.push(block.type === BLOCK.CARD ? {
      type: BLOCK.CARDS,
      items: [block]
    } : block);
  });
  return out;
};

/** Renders a display field's body. Copy with no markers is one paragraph. */
const RichBody = ({
  body
}) => React.createElement(React.Fragment, null, runs(parseBody(body)).map((block, i) => {
  // eslint-disable-next-line react/no-array-index-key
  const key = `${block.type}-${i}`;
  if (block.type === BLOCK.CARDS) {
    return React.createElement("div", {
      className: "cp-rbcards",
      key: key
    }, block.items.map(card => React.createElement(Card, {
      block: card,
      key: card.title
    })));
  }
  if (block.type === BLOCK.NOTE) {
    return React.createElement("p", {
      className: "cp-rbnote",
      key: key
    }, block.text);
  }
  if (block.type === BLOCK.HELP) return React.createElement(Help, {
    block: block,
    key: key
  });
  return React.createElement("p", {
    className: "cp-ivbody",
    key: key
  }, block.text);
}));
export default RichBody;
